export class AbstractProcessor {
    static className = 'AbstractProcessor';

    execute() {

    }
}


// WEBPACK FOOTER //
// ./src/service/checkout/quote/processor/AbstractProcessor.js